import { Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
// media query
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate } from 'react-router-dom';
export const AdminDashboard = ({openDrawer,toggleDrawer}) => {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'))
    useEffect(()=>{
        if(!user){
            window.location.href = '/'
        }
    },[])
    const [menus,setMenus] = useState([
        {
            name:'Judges',
            url:'/dashboard/judges'
        },{
            name:'Participants',
            url:'/dashboard/participants'
        },{
            name:'Voting',
            url:'/dashboard/voting'
        },{
          name:'Games',
          url:'/dashboard/games'
      }
    ])
    const DrawerList = (
        <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
          <List>
            {menus.map((text, index) => (
              <ListItem key={text.name} disablePadding>
                <ListItemButton onClick={()=>navigate(text.url)}>
                  <ListItemIcon>
                    {/* {index % 2 === 0 ? <InboxIcon /> : <MailIcon />} */}
                  </ListItemIcon>
                  <ListItemText primary={text.name}/>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      );
    return (
        <>
            {
                user.role === 1
                ?
                <div>
                    <Drawer open={openDrawer} onClose={toggleDrawer(false)}>
                        {DrawerList}
                    </Drawer>
                    </div>
                :
                null
            }
        </>
        
    )
}